import { LOCATION_CHANGE } from 'connected-react-router';
import { createLogic } from 'redux-logic';
import get from 'lodash/get';
import { setBookingChannel } from 'store/checkout/checkoutActions';
import { LUXE_HOST } from 'config';
import { getRouteMatchForURL } from 'components/Routes';
import { getBookingChannel } from 'store/checkout/checkoutSelectors';

const LUXE_CHANNEL = 'qantas_luxe_website';
const QANTAS_HOTELS_WEBSITE_CHANNEL = 'qantas_hotels_website';

const isLuxeReferrer = () => (window?.document?.referrer ?? '').startsWith(LUXE_HOST);

export const bookingChannelLogic = createLogic({
  type: LOCATION_CHANGE,
  latest: true,
  async process({ action, getState }, dispatch, done) {
    const { isFirstRendering } = action.payload;
    const state = getState();
    const pathName = get(state, 'router.location.pathname');
    const { name: routeName } = getRouteMatchForURL(pathName) || {};
    const previousBookingChannel = getBookingChannel(state);

    // We only want to set the booking channel as luxe if we've landed directly on the checkout
    // with luxe as the referrer (hence isFirstRendering), otherwise treat as Qantas Hotels
    const channel = isFirstRendering && isLuxeReferrer() ? LUXE_CHANNEL : QANTAS_HOTELS_WEBSITE_CHANNEL;

    // If the user arrived at confirmation from checkout, do not change the booking channel
    if (routeName !== 'booking-confirmation' || !previousBookingChannel) {
      dispatch(setBookingChannel(channel));
    }

    done();
  },
});
